import { Component, OnInit } from '@angular/core';
import { CompanyService } from 'app/services/company.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent implements OnInit {
  privacyPolicy: string;
  isLoading: boolean = false;

  constructor(private companyService: CompanyService) {}

  ngOnInit() {
    this.getPrivacyPolicy();
  }

  getPrivacyPolicy() {
    this.isLoading = true;
    this.companyService.getPrivacyPolicy().subscribe(
      (data: any) => {
        this.privacyPolicy = data?.privacyPolicy;
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching privacy policy', error);
        this.isLoading = false;
      }
    );
  }
}
